import script from "./PageHotspots.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHotspots.vue?vue&type=script&setup=true&lang=js"

import "./PageHotspots.vue?vue&type=style&index=0&id=00112b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_postcss@8.5.32_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00112b84"]])

export default __exports__